import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Capitales, ICamposCapitalesRes, IGetCapitalesProm } from "@p-p-portafolio/promociones/interfaces/capitales";
import { ConceptoCapitales } from "@p-p-portafolio/promociones/interfaces/concepto-capitales";
import { EntityOperationResult } from "@shared/interfaces/responses/entity-operation-result";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class CapitalesService {
    private baseUrl = environment.apiBaseUrl + "api/Capitales";
    private baseUrlCatalog = environment.apiBaseUrl + "api/AtencionAgendas/PostCmSpR_CampoDeTablaWhere";

    constructor(private http: HttpClient) {}

    form: UntypedFormGroup = new UntypedFormGroup({
        sPromocion: new UntypedFormControl(""),
        concepto: new UntypedFormControl(null),
        conceptoInteres: new UntypedFormControl(null),
    });

    initializeFormGroup() {
        this.form.setValue({
            sPromocion: "",
            concepto: null,
            conceptoInteres: null,
        });
    }

    populateForm(entity: Capitales) {
        this.form.setValue(entity);
    }

    getCatalogDropdownCapitales(payload: ICamposCapitalesRes) {
        return this.http.post<any>(this.baseUrlCatalog, payload);
    }

    getAll(payload: IGetCapitalesProm) {
        const url = `${this.baseUrl}/GetCapitalesProm`;
        return this.http.post<any>(url, payload);
    }

    getCapital() {
        const url = `${this.baseUrl}`;
        return this.http.get<ConceptoCapitales[]>(url);
    }

    getById(id: string) {
        const url = `${this.baseUrl}/${id}`;
        return this.http.get<Capitales>(url);
    }

    add(entity: IGetCapitalesProm) {
        const url = `${this.baseUrl}/SetCapitalesProm`;
        return this.http.post<any>(url, entity);
    }

    update(entity: IGetCapitalesProm) {
        const url = `${this.baseUrl}/SetCapitalesProm`;
        return this.http.post<any>(url, entity);
    }

    delete(entity: IGetCapitalesProm) {
        const url = `${this.baseUrl}/SetCapitalesProm`;
        return this.http.post<any>(url, entity);
    }
}
